<template>
  <qx-card title="油消费记录">
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            >
              <section  slot-scope="scope">
                <section v-if="scope.column.property === 'limit'">
                  不限
                </section>
                <section v-if="scope.column.property === 'useQuotaAmt'">
                  <span>{{scope.row[scope.column.property] ?  scope.row[scope.column.property]/ 100 : 0}}</span>
                </section>
                <section
                  v-if="scope.column.property !== 'limit' && scope.column.property !== 'useQuotaAmt'"
                >{{scope.row[scope.column.property]}}</section>
              </section>
            </el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  oilAccountSiteDetailList, // 消费列表
} from 'api/service';
export default {
  mixins: [
    tableMixin,
  ],
  data () {
    return {
      totalData: {
        amount: 0, // 总金额
        fleetRebateAmount: 0, // 返利金额
        oilRise: 0, // 加油升数
      },
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'serviceName',
            label: '服务商名称',
          },
          {
            prop: 'limit',
            label: '额度',
          },
          {
            prop: 'useQuotaAmt',
            label: '已用',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: oilAccountSiteDetailList,
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
